import ErrorTypeEnum from '../../constants/enums/ErrorTypeEnum';
import BaseApplicationError from './base/BaseApplicationError';

class ApplicationError extends BaseApplicationError {
  public readonly type = ErrorTypeEnum.ApplicationError;

  public unknownError?: unknown;
  public innerErrorMessage?: unknown;
  public innerErrorStack?: unknown;
  public innerErrorName?: unknown;
  public isAxiosError?: boolean | undefined;
  public isCancel?: boolean | undefined;

  public static fromUnknown(error: unknown): ApplicationError {
    const applicationError = new ApplicationError();

    applicationError.unknownError = error;

    if (error instanceof Error) {
      applicationError.innerErrorMessage = error.message;
      applicationError.innerErrorStack = error.stack;
      applicationError.innerErrorName = error.name;
    }

    return applicationError;
  }
}

export default ApplicationError;
